/**
 * A relation denoting a usage from another entity. Reversed direction of
 * {@link RELATION_USER_OF}.
 *
 * @public
 */
export const RELATION_USED_BY = 'usedBy';

/**
 * A relation denoting a usage on another entity. Reversed direction of
 * {@link RELATION_USED_BY}.
 *
 * @public
 */
export const RELATION_USER_OF = 'userOf';

/**
 * A relation denoting a usage from another entity. Reversed direction of
 * {@link RELATION_HOSTS}.
 *
 * @public
 */
export const RELATION_DEPLOYED_IN = 'deployedIn';

/**
 * A relation denoting a usage on another entity. Reversed direction of
 * {@link RELATION_DEPLOYED_IN}.
 *
 * @public
 */
export const RELATION_HOSTS = 'hosts';

/**
 * A relation denoting a usage from another entity. Reversed direction of
 * {@link RELATION_PROVIDES_DATA_TO}.
 *
 * @public
 */
export const RELATION_CONSUMES_DATA_FROM = 'consumesDataFrom';

/**
 * A relation denoting a usage on another entity. Reversed direction of
 * {@link RELATION_CONSUMES_DATA_FROM}.
 *
 * @public
 */
export const RELATION_PROVIDES_DATA_TO = 'providesDataTo';
